import { render, staticRenderFns } from "./AddDispatch.vue?vue&type=template&id=2fc95695&"
import script from "./AddDispatch.vue?vue&type=script&lang=js&"
export * from "./AddDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports